const CheckoutType = {
    ADJUSTMENT: 'ADJUSTMENT',

    BALANCE_PAYMENT: 'BALANCE_PAYMENT',

    NEW_ORDER__CONFIRMED: 'NEW_ORDER__CONFIRMED',

    NEW_ORDER__UNCONFIRMED: 'NEW_ORDER__UNCONFIRMED',

    NEW_ORDER__OFFLINE: 'NEW_ORDER__OFFLINE',
};

module.exports = CheckoutType;
